import { SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { classNames } from '../../utils/helpers';

export interface SelectOption { value: string; label: string }

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  options: SelectOption[];
  label?: string;
  placeholder?: string;
}

export default function Select({ options, label, placeholder, className = '', ...rest }: SelectProps) {
  return (
    <label className="block">
      {label && <span className="block text-xs font-medium text-gray-600 mb-1">{label}</span>}
      <div className="relative">
        <select
          className={classNames(
            'appearance-none w-full text-sm rounded-lg border border-gray-300 bg-white px-3 py-2 pr-9',
            'focus:outline-none focus:ring-2 focus:ring-brand/30 focus:border-brand',
            className,
          )}
          {...rest}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <ChevronDown size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
      </div>
    </label>
  );
}
